import { PaymentMethod } from 'modules/purchase/constants'

import { Cohort } from 'root-constants'

export const PAYWALL_GOOGLE_PAY_DISABLED_COHORTS: readonly string[] = [
  Cohort.AP_WLDB_313,
  Cohort.AP_WLDB_QUIZ_313,
]

export const CHECKOUT_CARD_FIRST_PAYMENT_METHODS: readonly PaymentMethod[] = [
  PaymentMethod.CREDIT_CARD,
  PaymentMethod.GOOGLE_PAY,
  PaymentMethod.APPLE_PAY,
  PaymentMethod.PAYPAL,
]

export const CHECKOUT_PAYMENT_PRIORITY_BY_COHORT: Partial<
  Record<string, readonly PaymentMethod[]>
> = {
  [Cohort.AP_WLDB_313]: CHECKOUT_CARD_FIRST_PAYMENT_METHODS,
  [Cohort.AP_WLDB_QUIZ_313]: CHECKOUT_CARD_FIRST_PAYMENT_METHODS,
}
